import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Text } from '@app-masters/react-lib';

class Cellphone extends Component {
    render () {
        const push = this.props.interaction.options[0];

        return (
            <div className='interaction oldcellphone' onClick={() => this.props.action(push.value)}>
                <div className='text-container'>
                    <div className='text'>
                        <span>{'De: ' + this.props.interaction.from}</span>
                        <br />
                        <br />
                        <span className='greeting'>
                            {this.props.interaction.content.subject}
                        </span>
                        <br />
                        <span>{Text.nl2br(this.props.interaction.content.message)}</span>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({user}) => ({
    user: user.user
});

export default connect(mapStateToProps)(Cellphone);



// WEBPACK FOOTER //
// ./src/views/InteractionViews/oldCellphoneView.js